import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

import Top from '../navigation/top';
import { FormRow } from '../form/formField';

const initialState = {};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    groupno: { label: 'ProductCombo #', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    name: { label: 'Name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    groupA: { label: 'Group A', type: 'array', readonly: false, help: 'Field is DealerWeb only.' },
    groupB: { label: 'Group B', type: 'array', readonly: false, help: 'Field is DealerWeb only.' },
};

@observer
class ProductComboEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { productComboStore } = this.props.stores;
        productComboStore.load(props.id);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'groupno', 'sort', 'name', 'groupA', 'groupB'].map(f => util.makeField(f, FIELDS)),
            },
        ];
    }

    updateField = async (id, field, value, type) => {
        const { productComboStore } = this.props.stores;
        const val = type === 'array' ? value.replace(/[\n\t\r]/g, ',').split(',').map(e => e.trim()) : value;
        productComboStore.updateField(id, field, val);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, val);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { productComboStore } = this.props.stores;
        await productComboStore.saveField(id, field, value);
    }

    render(props) {
        const { productComboStore } = this.props.stores;
        const { productCombo, saved } = productComboStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/productcombos' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {productCombo.id}: {productCombo.name}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/productcombos/${props.id}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={productCombo}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default ProductComboEdit;



// WEBPACK FOOTER //
// ./components/productcombos/edit.js